import React from 'react'
import clsx from 'clsx'
import { Popover as PopoverStyles } from '@airbus/elements/elements'
import { createUseStyles } from '../../lib/styling'
import Popper, { PopperProps } from '../Popper'

export type PopoverProps = PopperProps

const useStyles = createUseStyles(PopoverStyles, 'popover')

export const Popover = (props: PopoverProps, ref: React.Ref<HTMLDivElement>) => {
  const { arrowClassName, className, children, ...rest } = props
  const classes = useStyles()

  return (
    <Popper className={clsx(className, classes.root)} arrowClassName={clsx(classes.arrow, arrowClassName)} {...rest}>
      <div ref={ref}>{children}</div>
    </Popper>
  )
}

export default React.forwardRef<HTMLDivElement, PopoverProps>(Popover)
